import React, { Component } from 'react';
import { connect } from 'react-redux';

class Hidden extends Component {
  render() {
    return this.props.hidden > 0 &&
          (<span style={{fontSize:'9px'}}> {`- ${this.props.hidden} Hidden due to Max Collateral and Trade Window`} </span>)
  }
}

function mapStateToProps(state,props) {
  return { hidden: state.orderbook.hidden};
}

export default connect(mapStateToProps, {})(Hidden);
